module.exports = __webpack_public_path__ + "static/media/Javascript-shield.fd323a10.svg";